import React from "react";
import { SovosButton } from "mosaic-react";
import { AddCircleOutline } from "mosaic-react-icons";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const SettingsCreateButton = ({ typename }) => {
    const { pushModal, i18n, reload } = useGlobalValue();

    if (!typename) return null;

    return (
        <SovosButton
            key="settingsCreate"
            children={i18n`New ${typename}`}
            startIcon={<AddCircleOutline />}
            onClick={() => {
                pushModal({
                    title: i18n`New ${typename}`,
                    view: `${typename}Form`,
                    data: { __typename: typename },
                })
                    .then(() => {
                        reload && reload();
                    })
                    .catch(() => null);
            }}
        />
    );
};

export default SettingsCreateButton;
